export default function Video() {
  return <div className="Video">
    <h1>Video</h1>
    <div style={{maxHeight: "calc(100vh - var(--nav-height))", width: "100%", height: "calc((100vw - (2 * var(--page-margin, 0))) * 0.5625)"}}>
      <iframe src="https://player.vimeo.com/video/604358625?h=33cf9ef0bc&amp;title=0&amp;byline=0&amp;portrait=0&amp;playsinline=0&amp;autopause=0&amp;app_id=122963" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen="" title="Alison + Andrew | Elopement - Maui, Hawaii." style={{width: "100%", height: "100%"}}></iframe>
    </div>
  </div>;
}